import { CssBaseline } from "@mui/material";
import * as Sentry from "@sentry/react";
import { wrapUseRoutes } from "@sentry/react";
import { useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import router from "src/router/router";
import defineAbilityFor from "./config/ability";
import { AbilityContext } from "./context/canContext";
import DialogProvider from "./context/dialogContext";
import {
  ThemeProviderWrapper,
  selectTheme,
  themeNames,
} from "./features/appTheme";
import { useAppSelector } from "./hooks/hooks";
import Status500 from "./pages/Fallbacks/Status/Status500/Status500";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAuthenticate } from "./hooks/useAuthenticate";

// Sentry.init(sentryConfig)
const useSentryRoutes = wrapUseRoutes(useRoutes);

function App() {
  const content = useSentryRoutes(router);
  const theme = useAppSelector(selectTheme);
  const ability = defineAbilityFor("superAdmin"); //TODO: the user role should be added here

  useAuthenticate();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProviderWrapper>
        <Sentry.ErrorBoundary
          fallback={
            <Status500 resetErrorBoundary={() => window.location.reload()} />
          }
        >
          <AbilityContext.Provider value={ability}>
            <CssBaseline />
            <DialogProvider>
              <ToastContainer
                theme={theme === themeNames.dark ? "dark" : "light"}
              />
              {content}
            </DialogProvider>
          </AbilityContext.Provider>
        </Sentry.ErrorBoundary>
      </ThemeProviderWrapper>
    </LocalizationProvider>
  );
}

export default App;
